import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";

const PromiseSection = () => {
    return (
        <Box
            sx={{
                background: "#000",
                py: 12,
                px: { xs: 3, md: 12 },
                color: "#fff",
            }}
        >
            {/* TOP TITLE */}
            
            <Box sx={{ mb: 6 }}>
                <Typography
                    variant="h3"
                    component="span"
                    sx={{
                        color: "#fff",
                        fontSize: { xs: '30px', md: "35px" },
                        fontWeight: 700,
                        letterSpacing: 2,
                        mr: 1,
                    }}
                >
                    Still Not
                </Typography>

                <Typography
                    variant="h1"
                    sx={{
                        background:
                            "linear-gradient(90deg, #ffffff 0%, #d4af37 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        position: "relative",
                        display: "inline-block",
                        fontWeight: 700,
                        fontSize: { xs: "50px", md: "auto" },
                        "&::after": {
                            content: '""',
                            position: "absolute",
                            bottom: "0px",
                            left: 0,
                            width: "100%",
                            height: "10px",
                            background: "rgb(177 177 177 / 50%)",
                            borderRadius: "4px",
                        },
                    }}
                >
                    Sure?
                </Typography>
            </Box>

          

            {/* MAIN CONTENT */}
            <Grid container spacing={6} alignItems="center">
                {/* BADGE */}
                <Grid item xs={12} md={4} textAlign="center">
                    <Box
                        component="img"
                        src="https://cdn-icons-png.flaticon.com/512/2583/2583344.png"
                        sx={{
                            width: 180,
                            filter: "drop-shadow(0 10px 25px rgba(0,0,0,0.4))",
                        }}
                    />
                </Grid>

                {/* TEXT */}
                <Grid item xs={12} md={8} textAlign='start'>
                    <Typography variant="h4" fontWeight={700} mb={2} sx={{ color: "white",textAlign:'start' }}>
                        Here’s What You Can Expect
                    </Typography>

                    <Typography
                        sx={{
                            opacity: 0.9,
                            lineHeight: 1.7,
                            maxWidth: 650,
                            color: "white",
                            textAlign:'start'
                        }}
                    >
                        This is not a motivational session. It is a practical masterclass focused on Luxury sales challenges. You will gain clarity on where your sales conversations may be slowing revenue, understand how structure improves conversions, and leave with actionable direction you can implement immediately.
                    </Typography>

                    <Button
                        sx={{
                            mt: 4,
                            px: 5,
                            py: 1.8,
                            borderRadius: "40px",
                            background: "#0f63a5",
                            color: "#fff",
                            textAlign:'start',
                            fontWeight: 700,
                            letterSpacing: 1,
                            "&:hover": {
                                background: "#fff",
                                color: "#0f63a5",
                            },
                        }}
                    >
                        REGISTER FOR THE LIVE MASTERCLASS
                    </Button>
                </Grid>
            </Grid>

            {/* VINTAGE LETTER SECTION */}
            <Box
                sx={{
                    mt: 12,
                    maxWidth: 900,
                    mx: "auto",
                    px: { xs: 4, md: 8 },
                    py: 8,
                    borderRadius: "12px",
                    backgroundImage:
                        "url(https://www.transparenttextures.com/patterns/aged-paper.png)",
                    backgroundColor: "#f3e6c9",
                    backgroundBlendMode: "multiply",
                    boxShadow: "0 30px 70px rgba(0,0,0,0.6)",
                    border: "1px solid rgba(0,0,0,0.2)",
                    position: "relative",
                }}
            >
                {/* Title */}
                <Typography
                    variant="h4"
                    fontWeight={700}
                    sx={{
                        fontFamily: "Georgia, serif",
                        color: "#3a2e1f",
                        mb: 3,
                    }}
                >
                    A Commitment From My Side
                </Typography>

                <Box
                    sx={{
                        width: 120,
                        height: 2,
                        background: "#8b6f47",
                        mb: 4,
                    }}
                />

                {/* Text */}
                <Typography
                    sx={{
                        fontFamily: "Georgia, serif",
                        fontSize: 18,
                        lineHeight: 1.9,
                        color: "#3a2e1f",
                    }}
                >
                    Over the years, I’ve worked closely with high-value sales environments,
                    leadership teams, and growing organisations. One pattern has remained
                    constant: sales improve when conversations become structured,
                    intentional, and psychologically aligned.
                </Typography>

                <Typography
                    sx={{
                        fontFamily: "Georgia, serif",
                        fontSize: 18,
                        lineHeight: 1.9,
                        mt: 2,
                        color: "#3a2e1f",
                    }}
                >
                    This masterclass is designed to help you recognise where your revenue
                    conversations may be slowing growth and how small shifts in structure
                    can create meaningful results.
                </Typography>

                {/* Signature */}
                <Typography
                    sx={{
                        mt: 5,
                        fontFamily: "Georgia, serif",
                        fontSize: 20,
                        fontWeight: 700,
                        color: "#5a4630",
                    }}
                >
                    — Rajiv Williams
                </Typography>

                <Typography
                    sx={{
                        fontFamily: "Georgia, serif",
                        opacity: 0.8,
                        color: "#5a4630",
                    }}
                >
                    Sales Strategist
                </Typography>
            </Box>
        </Box>
    );
};

export default PromiseSection;